define('handlebarsHelper',
[
    'handlebars',
    'jquery'
], function(Handlebars, $) {

    var handlebarsHelper = {
        init: function() {
            this.registerConditionals();
            this.registerForLoop();
            this.registerMathsOperators();
        },

        /**
         * Register the if-conditional helper with Handlebars.
         */
        registerConditionals: function() {
            Handlebars.registerHelper('ifCond', function(v1, operator, v2, options) {
                switch (operator) {
                    case '==':
                        return (v1 == v2) ? options.fn(this) : options.inverse(this);
                    case '===':
                        return (v1 === v2) ? options.fn(this) : options.inverse(this);
                    case '!=':
                        return (v1 != v2) ? options.fn(this) : options.inverse(this);
                    case '!==':
                        return (v1 !== v2) ? options.fn(this) : options.inverse(this);
                    case '<':
                        return (v1 < v2) ? options.fn(this) : options.inverse(this);
                    case '<=':
                        return (v1 <= v2) ? options.fn(this) : options.inverse(this);
                    case '>':
                        return (v1 > v2) ? options.fn(this) : options.inverse(this);
                    case '>=':
                        return (v1 >= v2) ? options.fn(this) : options.inverse(this);
                    case '&&':
                        return (v1 && v2) ? options.fn(this) : options.inverse(this);
                    case '||':
                        return (v1 || v2) ? options.fn(this) : options.inverse(this);
                    default:
                        return options.inverse(this);
                }
            });
        },

        /**
         * Register the loop helper with Handlebars.
         */
        registerForLoop: function() {
            Handlebars.registerHelper('for', function(from, to, incr, block) {
                var accum = '';
                for(var i = from; i <= to; i += incr)
                    accum += block.fn(i);
                return accum;
            });
        },

        /**
         * Register the math helper with Handlebars.
         */
        registerMathsOperators: function() {
            Handlebars.registerHelper("maths", function(lvalue, operator, rvalue, options) {
                lvalue = parseFloat(lvalue);
                rvalue = parseFloat(rvalue);

                return {
                    "+": lvalue + rvalue,
                    "-": lvalue - rvalue,
                    "*": lvalue * rvalue,
                    "/": lvalue / rvalue,
                    "%": lvalue % rvalue
                }[operator];
            });
        },

        /**
         * Get a template, cache it and precompile. If the template has been requested
         * previously it will be pulled from cache.
         */
        getTemplate: function(elementId) {
            if (!this.templateCache[elementId]) {
                var template = $(elementId).html();
                this.templateCache[elementId] = Handlebars.compile(template);
            }

            return this.templateCache[elementId];
        },

        templateCache: {}
    };

    handlebarsHelper.init();

    return handlebarsHelper;
});



// WEBPACK FOOTER //
// ./resources/assets/js/modules/handlebars-helper.js